import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useTitle } from '../../context/TitleContext';
import AddOrder from './components/AddOrder';
import '../../styles/products.scss';

const OrderEdit = () => {
  const { id } = useParams();
  const { setTitle } = useTitle();

  return (
    <Container fluid className="order-edit-page">
      <Row>
        <Col xl={12} lg={12}>
          <AddOrder isEdit={true} orderId={id} />
        </Col>
      </Row>
    </Container>
  );
};

export default OrderEdit;
